var map = {
	"../../+private-page/private.module": [
		"../../../../../src/app/lazy-modules/+private-page/private.module.ts",
		"private.module"
	],
	"../.././restaurant/restnt-report/restnt-consolidatereports/restnt-consolidatereports.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/restnt-report/restnt-consolidatereports/restnt-consolidatereports.module.ts",
		"common",
		"restnt-consolidatereports.module"
	],
	"../layout/layout.module": [
		"../../../../../src/app/lazy-modules/+app/layout/layout.module.ts",
		"layout.module"
	],
	"./account-reports/account-reports.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/acreports/account-reports/account-reports.module.ts",
		"account-reports.module"
	],
	"./account-transaction-doc/account-transaction-doc.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/account-transaction-doc/account-transaction-doc.module.ts",
		"account-transaction-doc.module"
	],
	"./account-transaction-list/account-transaction-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/account-transaction-list/account-transaction-list.module.ts",
		"account-transaction-list.module"
	],
	"./account-transaction/account-transaction.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/account-transaction/account-transaction.module.ts",
		"common",
		"account-transaction.module"
	],
	"./account-transactions/account-transactions.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/account-transactions.module.ts",
		"account-transactions.module"
	],
	"./accounts/accounts.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/accounts.module.ts",
		"accounts.module"
	],
	"./acctools/acctools.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/acctools/acctools.module.ts",
		"acctools.module"
	],
	"./acreports/acreports.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/acreports/acreports.module.ts",
		"acreports.module"
	],
	"./adcashcollection/adcashcollection.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/advancecashcollection-grp/adcashcollection/adcashcollection.module.ts",
		"common",
		"adcashcollection.module"
	],
	"./advancecashcollection-grp/advancecashcollection-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/advancecashcollection-grp/advancecashcollection-grp.module.ts",
		"advancecashcollection-grp.module"
	],
	"./advancecashcollection-list/advancecashcollection-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/advancecashcollection-grp/advancecashcollection-list/advancecashcollection-list.module.ts",
		"advancecashcollection-list.module"
	],
	"./approval-list/approval-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/approval-list/approval-list.module.ts",
		"approval-list.module"
	],
	"./approved-list/approved-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/approved-list/approved-list.module.ts",
		"approved-list.module"
	],
	"./area/area.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/area/area.module.ts",
		"area.module"
	],
	"./backofficesale-grp/backofficesale-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/backofficesale-grp/backofficesale-grp.module.ts",
		"backofficesale-grp.module"
	],
	"./backofficesale-list/backofficesale-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/backofficesale-grp/backofficesale-list/backofficesale-list.module.ts",
		"backofficesale-list.module"
	],
	"./backofficesale/backofficesale.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/backofficesale-grp/backofficesale/backofficesale.module.ts",
		"common",
		"backofficesale.module"
	],
	"./billpayments/billpayment-list/billpayment-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/billpayments/billpayment-list/billpayment-list.module.ts",
		"billpayment-list.module"
	],
	"./billpayments/billpayment/billpayment.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/billpayments/billpayment/billpayment.module.ts",
		"common",
		"billpayment.module"
	],
	"./billreciepts/billreciept-list/billreciept-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/billreciepts/billreciept-list/billreciept-list.module.ts",
		"billreciept-list.module"
	],
	"./billreciepts/billreciept/billreciept.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/billreciepts/billreciept/billreciept.module.ts",
		"common",
		"billreciept.module"
	],
	"./brand/brand.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/master/brand/brand.module.ts",
		"brand.module"
	],
	"./buyxgetypromotion-grp/buyxgetypromotion-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/buyxgetypromotion-grp/buyxgetypromotion-grp.module.ts",
		"buyxgetypromotion-grp.module"
	],
	"./buyxgetypromotion/buyxgetypromotion.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/buyxgetypromotion-grp/buyxgetypromotion/buyxgetypromotion.module.ts",
		"common",
		"buyxgetypromotion.module"
	],
	"./buyxgetypromotionnew/buyxgetypromotionnew.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/buyxgetypromotion-grp/buyxgetypromotionnew/buyxgetypromotionnew.module.ts",
		"common",
		"buyxgetypromotionnew.module"
	],
	"./ca-master/ca-master.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/ca-master/ca-master.module.ts",
		"ca-master.module"
	],
	"./cashcollection-posting/cashcollection-posting.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/cashcollection-posting/cashcollection-posting.module.ts",
		"cashcollection-posting.module"
	],
	"./cashier/cashier.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/pos/cashier/cashier.module.ts",
		"cashier.module"
	],
	"./category/category.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/category/category.module.ts",
		"category.module"
	],
	"./chart-of-accounts/chart-of-accounts.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/ca-master/chart-of-accounts/chart-of-accounts.module.ts",
		"common",
		"chart-of-accounts.module"
	],
	"./chequeissue/chequeissue.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/acctools/chequeissue/chequeissue.module.ts",
		"chequeissue.module"
	],
	"./chequeprint-grp/chequeprint-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/chequeprint-grp/chequeprint-grp.module.ts",
		"chequeprint-grp.module"
	],
	"./closing-reports/closing-reports.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/reports/closing-reports/closing-reports.module.ts",
		"closing-reports.module"
	],
	"./colour/colour.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/master/colour/colour.module.ts",
		"colour.module"
	],
	"./combo-item-list/combo-item-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/combo-item/combo-item-list/combo-item-list.module.ts",
		"combo-item-list.module"
	],
	"./combo-item/combo-item.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/combo-item/combo-item.module.ts",
		"combo-item.module"
	],
	"./common-fromMail/common-fromMail.module": [
		"../../../../../src/app/lazy-modules/+private-page/tools/common-fromMail/common-fromMail.module.ts",
		"common",
		"common-fromMail.module"
	],
	"./common-mail/common-mail.module": [
		"../../../../../src/app/lazy-modules/+private-page/tools/common-mail/common-mail.module.ts",
		"common",
		"common-mail.module"
	],
	"./common-settings/common-settings.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/companyStructure/common-settings/common-settings.module.ts",
		"common",
		"common-settings.module"
	],
	"./company-stucture/company-stucture.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/companyStructure/company-stucture/company-stucture.module.ts",
		"common",
		"company-stucture.module"
	],
	"./companyStructure/companyStructure.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/companyStructure/companyStructure.module.ts",
		"common",
		"companyStructure.module"
	],
	"./consumption-grp/consumption-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/consumption-grp/consumption-grp.module.ts",
		"consumption-grp.module"
	],
	"./consumption-list/consumption-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/consumption-grp/consumption-list/consumption-list.module.ts",
		"consumption-list.module"
	],
	"./consumption/consumption.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/consumption-grp/consumption/consumption.module.ts",
		"consumption.module"
	],
	"./cost-adjustment-grp/cost-adjustment-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/cost-adjustment-grp/cost-adjustment-grp.module.ts",
		"cost-adjustment-grp.module"
	],
	"./cost-adjustment-list/cost-adjustment-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/cost-adjustment-grp/cost-adjustment-list/cost-adjustment-list.module.ts",
		"cost-adjustment-list.module"
	],
	"./cost-adjustment/cost-adjustment.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/cost-adjustment-grp/cost-adjustment/cost-adjustment.module.ts",
		"common",
		"cost-adjustment.module"
	],
	"./counter/counter.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/pos/counter/counter.module.ts",
		"counter.module.0"
	],
	"./counteritems/counteritems.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/counteritems/counteritems.module.ts",
		"counteritems.module"
	],
	"./counters/counter.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/counters/counter.module.ts",
		"counter.module"
	],
	"./countryMaster/countryMaster.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/countryMaster/countryMaster.module.ts",
		"countryMaster.module"
	],
	"./course-type/course-type.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/course-type/course-type.module.ts",
		"course-type.module"
	],
	"./create-combo-item/create-combo-item.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/combo-item/create-combo-item/create-combo-item.module.ts",
		"create-combo-item.module"
	],
	"./currency-details/currency-details.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/currency-details/currency-details.module.ts",
		"currency-details.module"
	],
	"./currency-master/currency-master.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/currency-master/currency-master.module.ts",
		"currency-master.module"
	],
	"./currency/currency.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/master/currency/currency.module.ts",
		"currency.module"
	],
	"./customer-grp/customer-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/customer-grp/customer-grp.module.ts",
		"customer-grp.module"
	],
	"./customer-list/customer-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/customer-grp/customer-list/customer-list.module.ts",
		"customer-list.module"
	],
	"./customer/customer.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/customer-grp/customer/customer.module.ts",
		"customer.module"
	],
	"./customerservice-grp/customerservice-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/customerservice-grp/customerservice-grp.module.ts",
		"customerservice-grp.module"
	],
	"./customerservice-list/customerservice-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/customerservice-grp/customerservice-list/customerservice-list.module.ts",
		"customerservice-list.module"
	],
	"./customerservice/customerservice.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/customerservice-grp/customerservice/customerservice.module.ts",
		"customerservice.module"
	],
	"./damage-grp/damage-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/damage-grp/damage-grp.module.ts",
		"damage-grp.module"
	],
	"./damage-list/damage-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/damage-grp/damage-list/damage-list.module.ts",
		"damage-list.module"
	],
	"./damage/damage.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/damage-grp/damage/damage.module.ts",
		"common",
		"damage.module"
	],
	"./databasebackup/databasebackup.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/databasebackup/databasebackup.module.ts",
		"databasebackup.module"
	],
	"./datechange/datechange.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/pos/datechange/datechange.module.ts",
		"datechange.module"
	],
	"./debitnote-distribution-grp/debitnote-distribution-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/debitnote-distribution-grp/debitnote-distribution-grp.module.ts",
		"debitnote-distribution-grp.module"
	],
	"./debitnote-distribution-list/debitnote-distribution-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/debitnote-distribution-grp/debitnote-distribution-list/debitnote-distribution-list.module.ts",
		"debitnote-distribution-list.module"
	],
	"./debitnote-distribution/debitnote-distribution.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/debitnote-distribution-grp/debitnote-distribution/debitnote-distribution.module.ts",
		"debitnote-distribution.module"
	],
	"./deliveryarea/deliveryarea.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/master/deliveryarea/deliveryarea.module.ts",
		"deliveryarea.module"
	],
	"./deliverymgmt/deliverymgmt.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/deliverymgmt/deliverymgmt.module.ts",
		"deliverymgmt.module"
	],
	"./deliverynote-grp/deliverynote-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/deliverynote-grp/deliverynote-grp.module.ts",
		"deliverynote-grp.module"
	],
	"./deliverynote-list/deliverynote-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/deliverynote-grp/deliverynote-list/deliverynote-list.module.ts",
		"deliverynote-list.module"
	],
	"./deliverynote/deliverynote.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/deliverynote-grp/deliverynote/deliverynote.module.ts",
		"common",
		"deliverynote.module"
	],
	"./denomination/denomination.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/pos/denomination/denomination.module.ts",
		"denomination.module"
	],
	"./ecom-area/ecom-area.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/ecom-master/ecom-area/ecom-area.module.ts",
		"common",
		"ecom-area.module"
	],
	"./ecom-layout/ecom-layout.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/ecom-master/ecom-layout/ecom-layout.module.ts",
		"common",
		"ecom-layout.module"
	],
	"./ecom-master/ecom-master.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/ecom-master/ecom-master.module.ts",
		"common",
		"ecom-master.module"
	],
	"./ecom-propertytype/ecom-propertytype.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/ecom-master/ecom-propertytype/ecom-propertytype.module.ts",
		"common",
		"ecom-propertytype.module"
	],
	"./ecom-rider/ecom-rider.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/ecom-master/ecom-rider/ecom-rider.module.ts",
		"common",
		"ecom-rider.module"
	],
	"./ecom-state/ecom-state.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/ecom-master/ecom-state/ecom-state.module.ts",
		"common",
		"ecom-state.module"
	],
	"./ecom/ecom.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/ecom.module.ts",
		"common",
		"ecom.module"
	],
	"./employee/employee.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/employee/employee.module.ts",
		"employee.module"
	],
	"./excelvalidation/excelvalidation.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/excelvalidation/excelvalidation.module.ts",
		"excelvalidation.module"
	],
	"./favmenu/favmenu.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/favmenu/favmenu.module.ts",
		"favmenu.module"
	],
	"./finishedgoods/finishedgoods.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/production-grp/finishedgoods/finishedgoods.module.ts",
		"finishedgoods.module"
	],
	"./generate-item-relation/generate-item-relation.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/generate-item-relation/generate-item-relation.module.ts",
		"generate-item-relation.module"
	],
	"./giftcard-grp/giftcard-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/giftcard-grp/giftcard-grp.module.ts",
		"giftcard-grp.module"
	],
	"./giftcard-list/giftcard-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/giftcard-grp/giftcard-list/giftcard-list.module.ts",
		"giftcard-list.module"
	],
	"./giftcard-template-grp/giftcard-template-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/giftcard-template-grp/giftcard-template-grp.module.ts",
		"giftcard-template-grp.module"
	],
	"./giftcard-template-list/giftcard-template-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/giftcard-template-grp/giftcard-template-list/giftcard-template-list.module.ts",
		"common",
		"giftcard-template-list.module"
	],
	"./giftcard-template/giftcard-template.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/giftcard-template-grp/giftcard-template/giftcard-template.module.ts",
		"common",
		"giftcard-template.module"
	],
	"./giftcard/giftcard.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/giftcard-grp/giftcard/giftcard.module.ts",
		"giftcard.module"
	],
	"./giftcardItem/giftcardItem.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/giftcardItem/giftcardItem.module.ts",
		"giftcardItem.module"
	],
	"./glCodeMapping/glCodeMapping.module": [
		"../../../../../src/app/lazy-modules/+private-page/tools/glCodeMapping/glCodeMapping.module.ts",
		"glCodeMapping.module"
	],
	"./grn-grp/grn-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/grn-grp/grn-grp.module.ts",
		"grn-grp.module"
	],
	"./grn-list/grn-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/grn-grp/grn-list/grn-list.module.ts",
		"grn-list.module"
	],
	"./grn/grn.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/grn-grp/grn/grn.module.ts",
		"common",
		"grn.module"
	],
	"./home/home.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/home/home.module.ts",
		"common",
		"home.module"
	],
	"./hourly-promotion/hourly-promotion.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/hourly-promotion/hourly-promotion.module.ts",
		"hourly-promotion.module"
	],
	"./integration-info/integration-info.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/orderIntegration/integration-info/integration-info.module.ts",
		"common",
		"integration-info.module"
	],
	"./interbranch-transation-grp/interbranch-transation-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/interbranch-transation-grp/interbranch-transation-grp.module.ts",
		"interbranch-transation-grp.module"
	],
	"./interbranch-transation-list/interbranch-transation-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/interbranch-transation-grp/interbranch-transation-list/interbranch-transation-list.module.ts",
		"interbranch-transation-list.module"
	],
	"./interbranch-transation/interbranch-transation.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/interbranch-transation-grp/interbranch-transation/interbranch-transation.module.ts",
		"common",
		"interbranch-transation.module"
	],
	"./interbranchposting/interbranchposting.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/acctools/interbranchposting/interbranchposting.module.ts",
		"interbranchposting.module"
	],
	"./inventory-reports/inventory-reports.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/reports/inventory-reports/inventory-reports.module.ts",
		"inventory-reports.module"
	],
	"./inventory/inventory.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/inventory.module.ts",
		"common"
	],
	"./item-category-edit/item-category-edit.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/item-category-edit/item-category-edit.module.ts",
		"item-category-edit.module"
	],
	"./item/item.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/item/item.module.ts",
		"common",
		"item.module"
	],
	"./itemBanner-grp/itemBanner-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/ecom-master/itemBanner-grp/itemBanner-grp.module.ts",
		"itemBanner-grp.module"
	],
	"./itemBanner-list/itemBanner-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/ecom-master/itemBanner-grp/itemBanner-list/itemBanner-list.module.ts",
		"common",
		"itemBanner-list.module"
	],
	"./itemBanner/itemBanner.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/ecom-master/itemBanner-grp/itemBanner/itemBanner.module.ts",
		"common",
		"itemBanner.module"
	],
	"./itemcontrol/itemcontrol.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/itemcontrol/itemcontrol.module.ts",
		"itemcontrol.module"
	],
	"./itemwisepromotion-grp/itemwisepromotion-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/itemwisepromotion-grp/itemwisepromotion-grp.module.ts",
		"itemwisepromotion-grp.module"
	],
	"./itemwisepromotion/itemwisepromotion.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/itemwisepromotion-grp/itemwisepromotion/itemwisepromotion.module.ts",
		"common",
		"itemwisepromotion.module"
	],
	"./itemwisepromotionnew/itemwisepromotionnew.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/itemwisepromotion-grp/itemwisepromotionnew/itemwisepromotionnew.module.ts",
		"common",
		"itemwisepromotionnew.module"
	],
	"./kitchennote/kitchennote.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/kitchennote/kitchennote.module.ts",
		"kitchennote.module"
	],
	"./l-reports/l-reports.module": [
		"../../../../../src/app/lazy-modules/+private-page/loyalty/loyaltyreports/l-reports/l-reports.module.ts",
		"l-reports.module"
	],
	"./landing-grp/landing-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/ecom-master/landing-grp/landing-grp.module.ts",
		"landing-grp.module"
	],
	"./landing-list/landing-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/ecom-master/landing-grp/landing-list/landing-list.module.ts",
		"common",
		"landing-list.module"
	],
	"./landing/landing.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/ecom-master/landing-grp/landing/landing.module.ts",
		"common",
		"landing.module"
	],
	"./lazy-modules/+app/select-company/select-company.module": [
		"../../../../../src/app/lazy-modules/+app/select-company/select-company.module.ts",
		"common",
		"select-company.module"
	],
	"./lazy-modules/public-pages/+login/login.module": [
		"../../../../../src/app/lazy-modules/public-pages/+login/login.module.ts",
		"login.module"
	],
	"./ledgercreation/ledgercreation.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/acctools/ledgercreation/ledgercreation.module.ts",
		"ledgercreation.module"
	],
	"./ledgerreconciliation/ledgerreconciliation.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/ledgerreconciliation/ledgerreconciliation.module.ts",
		"ledgerreconciliation.module"
	],
	"./loyalty/loyalty.module": [
		"../../../../../src/app/lazy-modules/+private-page/loyalty/loyalty.module.ts",
		"common",
		"loyalty.module"
	],
	"./loyaltycard/loyaltycard.module": [
		"../../../../../src/app/lazy-modules/+private-page/loyalty/loyaltymaster/loyaltycard/loyaltycard.module.ts",
		"loyaltycard.module"
	],
	"./loyaltydeptsettings/loyaltydeptsettings.module": [
		"../../../../../src/app/lazy-modules/+private-page/loyalty/loyaltysettings/loyaltydeptsettings/loyaltydeptsettings.module.ts",
		"loyaltydeptsettings.module"
	],
	"./loyaltygiftvouchersettings/loyaltygiftvouchersettings.module": [
		"../../../../../src/app/lazy-modules/+private-page/loyalty/loyaltysettings/loyaltygiftvouchersettings/loyaltygiftvouchersettings.module.ts",
		"loyaltygiftvouchersettings.module"
	],
	"./loyaltymaster/loyaltymaster.module": [
		"../../../../../src/app/lazy-modules/+private-page/loyalty/loyaltymaster/loyaltymaster.module.ts",
		"loyaltymaster.module"
	],
	"./loyaltymember/loyaltymember.module": [
		"../../../../../src/app/lazy-modules/+private-page/loyalty/loyaltymaster/loyaltymember/loyaltymember.module.ts",
		"loyaltymember.module"
	],
	"./loyaltynationality/loyaltynationality.module": [
		"../../../../../src/app/lazy-modules/+private-page/loyalty/loyaltymaster/loyaltynationality/loyaltynationality.module.ts",
		"loyaltynationality.module"
	],
	"./loyaltyreports/loyaltyreports.module": [
		"../../../../../src/app/lazy-modules/+private-page/loyalty/loyaltyreports/loyaltyreports.module.ts",
		"loyaltyreports.module"
	],
	"./loyaltysettings/loyaltysettings.module": [
		"../../../../../src/app/lazy-modules/+private-page/loyalty/loyaltysettings/loyaltysettings.module.ts",
		"common",
		"loyaltysettings.module"
	],
	"./loyaltytransactions/loyaltytransactions.module": [
		"../../../../../src/app/lazy-modules/+private-page/loyalty/loyaltytransactions/loyaltytransactions.module.ts",
		"loyaltytransactions.module"
	],
	"./lpo/lpo.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/lpogrp/lpo/lpo.module.ts",
		"common",
		"lpo.module"
	],
	"./lpogrp/lpogrp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/lpogrp/lpogrp.module.ts",
		"lpogrp.module"
	],
	"./lpolist/lpolist.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/lpogrp/lpolist/lpolist.module.ts",
		"lpolist.module"
	],
	"./mail-log/mail-log.module": [
		"../../../../../src/app/lazy-modules/+private-page/tools/mail-log/mail-log.module.ts",
		"mail-log.module"
	],
	"./main/main.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/main.module.ts",
		"main.module"
	],
	"./master/master.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/master/master.module.ts",
		"master.module"
	],
	"./material-requisition-grp/material-requisition-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/material-requisition-grp/material-requisition-grp.module.ts",
		"material-requisition-grp.module"
	],
	"./material-requisition-list/material-requisition-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/material-requisition-grp/material-requisition-list/material-requisition-list.module.ts",
		"material-requisition-list.module"
	],
	"./material-requisition/material-requisition.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/material-requisition-grp/material-requisition/material-requisition.module.ts",
		"material-requisition.module"
	],
	"./menumigration/menumigration.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/menumigration/menumigration.module.ts",
		"menumigration.module"
	],
	"./mforxnforypromotion-grp/mforxnforypromotion-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/mforxnforypromotion-grp/mforxnforypromotion-grp.module.ts",
		"mforxnforypromotion-grp.module"
	],
	"./mforxnforypromotion/mforxnforypromotion.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/mforxnforypromotion-grp/mforxnforypromotion/mforxnforypromotion.module.ts",
		"common",
		"mforxnforypromotion.module"
	],
	"./mforxnforypromotionitem/mforxnforypromotionitem.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/mforxnforypromotion-grp/mforxnforypromotionitem/mforxnforypromotionitem.module.ts",
		"common",
		"mforxnforypromotionitem.module"
	],
	"./modifier-category/modifier-category.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/modifier-category/modifier-category.module.ts",
		"modifier-category.module"
	],
	"./onlinepaymentprovider/onlinepaymentprovider.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/pos/onlinepaymentprovider/onlinepaymentprovider.module.ts",
		"onlinepaymentprovider.module"
	],
	"./order-item/order-item.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/orderIntegration/order-item/order-item.module.ts",
		"order-item.module"
	],
	"./orderIntegration/orderIntegration.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/orderIntegration/orderIntegration.module.ts",
		"orderIntegration.module"
	],
	"./pdcpayment-grp/pdcpayment-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/pdcpayment-grp/pdcpayment-grp.module.ts",
		"pdcpayment-grp.module"
	],
	"./pdcpayment-list/pdcpayment-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/pdcpayment-grp/pdcpayment-list/pdcpayment-list.module.ts",
		"pdcpayment-list.module"
	],
	"./pdcpayment/pdcpayment.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/pdcpayment-grp/pdcpayment/pdcpayment.module.ts",
		"common",
		"pdcpayment.module"
	],
	"./pdcposting/pdcposting.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/pdcposting/pdcposting.module.ts",
		"pdcposting.module"
	],
	"./pdcreceipt-grp/pdcreceipt-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/pdcreceipt-grp/pdcreceipt-grp.module.ts",
		"pdcreceipt-grp.module"
	],
	"./pdcreceipt-list/pdcreceipt-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/pdcreceipt-grp/pdcreceipt-list/pdcreceipt-list.module.ts",
		"pdcreceipt-list.module"
	],
	"./pdcreceipt/pdcreceipt.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/pdcreceipt-grp/pdcreceipt/pdcreceipt.module.ts",
		"common",
		"pdcreceipt.module"
	],
	"./pickupmessage/pickupmessage.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/pickupmessage/pickupmessage.module.ts",
		"pickupmessage.module"
	],
	"./pointupdation/pointupdation.module": [
		"../../../../../src/app/lazy-modules/+private-page/loyalty/loyaltytransactions/pointupdation/pointupdation.module.ts",
		"pointupdation.module"
	],
	"./pos-currency/pos-currency.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/pos/pos-currency/pos-currency.module.ts",
		"pos-currency.module"
	],
	"./pos-deptgiftvouchersettings/pos-deptgiftvouchersettings.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/pos/pos-deptgiftvouchersettings/pos-deptgiftvouchersettings.module.ts",
		"pos-deptgiftvouchersettings.module"
	],
	"./pos-giftcard/pos-giftcard.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/pos/pos-giftcard/pos-giftcard.module.ts",
		"pos-giftcard.module"
	],
	"./pos-othercard/pos-othercard.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/pos/pos-othercard/pos-othercard.module.ts",
		"pos-othercard.module"
	],
	"./pos/pos.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/pos/pos.module.ts",
		"pos.module"
	],
	"./pospredefinedpromotion/pospredefinedpromotion.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/pos/pospredefinedpromotion/pospredefinedpromotion.module.ts",
		"pospredefinedpromotion.module"
	],
	"./posprivilege/posprivilege.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/pos/posprivilege/posprivilege.module.ts",
		"posprivilege.module"
	],
	"./pre-defined-discount/pre-defined-discount.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/pre-defined-discount/pre-defined-discount.module.ts",
		"pre-defined-discount.module"
	],
	"./pricechange/pricechange.module": [
		"../../../../../src/app/lazy-modules/+private-page/tools/pricechange/pricechange.module.ts",
		"pricechange.module"
	],
	"./pricelevel-location-mapping/pricelevel-location-mapping.module": [
		"../../../../../src/app/lazy-modules/+private-page/tools/pricelevel-location-mapping/pricelevel-location-mapping.module.ts",
		"pricelevel-location-mapping.module"
	],
	"./pricelevel/pricelevel.module": [
		"../../../../../src/app/lazy-modules/+private-page/tools/pricelevel/pricelevel.module.ts",
		"pricelevel.module"
	],
	"./priceupdation/priceupdation.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/priceupdation/priceupdation.module.ts",
		"priceupdation.module"
	],
	"./print-barcode/print-barcode.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/products/product-grp/print-barcode/print-barcode.module.ts",
		"print-barcode.module"
	],
	"./printer-item-mapping/printer-item-mapping.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/printer-item-mapping/printer-item-mapping.module.ts",
		"printer-item-mapping.module"
	],
	"./printer/printer.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/printer/printer.module.ts",
		"printer.module"
	],
	"./product-attribute/product-attribute.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/product/product-attribute/product-attribute.module.ts",
		"common",
		"product-attribute.module"
	],
	"./product-group/product-group.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/products/product-grp/product-group/product-group.module.ts",
		"common",
		"product-group.module"
	],
	"./product-grp/product-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/products/product-grp/product-grp.module.ts",
		"product-grp.module"
	],
	"./product-hierarchy/product-hierarchy.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/product/product-hierarchy/product-hierarchy.module.ts",
		"common",
		"product-hierarchy.module"
	],
	"./product-list/product-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/products/product-grp/product-list/product-list.module.ts",
		"product-list.module"
	],
	"./product-review-grp/product-review-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/product/product-review-grp/product-review-grp.module.ts",
		"product-review-grp.module"
	],
	"./product-review-list/product-review-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/product/product-review-grp/product-review-list/product-review-list.module.ts",
		"common",
		"product-review-list.module"
	],
	"./product-review/product-review.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/product/product-review-grp/product-review/product-review.module.ts",
		"common",
		"product-review.module"
	],
	"./product-taxonomy/product-taxonomy.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/product/product-taxonomy/product-taxonomy.module.ts",
		"common",
		"product-taxonomy.module"
	],
	"./product-tool/product-tool.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/products/product-grp/product-tool/product-tool.module.ts",
		"product-tool.module"
	],
	"./product/ecom-product.module": [
		"../../../../../src/app/lazy-modules/+private-page/ecom/product/ecom-product.module.ts",
		"common",
		"ecom-product.module"
	],
	"./product/product.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/products/product-grp/product/product.module.ts",
		"product.module"
	],
	"./production-grp/production-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/production-grp/production-grp.module.ts",
		"production-grp.module"
	],
	"./production-list/production-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/production-grp/production-list/production-list.module.ts",
		"production-list.module"
	],
	"./production/production.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/production-grp/production/production.module.ts",
		"common",
		"production.module"
	],
	"./productionconsumption-grp/productionconsumption-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/productionconsumption-grp/productionconsumption-grp.module.ts",
		"productionconsumption-grp.module"
	],
	"./productionconsumption-list/productionconsumption-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/productionconsumption-grp/productionconsumption-list/productionconsumption-list.module.ts",
		"productionconsumption-list.module"
	],
	"./productionconsumption/productionconsumption.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/productionconsumption-grp/productionconsumption/productionconsumption.module.ts",
		"productionconsumption.module"
	],
	"./products/products.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/products/products.module.ts",
		"products.module"
	],
	"./promotion-grp/promotion-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/promotion-grp/promotion-grp.module.ts",
		"promotion-grp.module"
	],
	"./promotion-items/promotion-items.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/hourly-promotion/promotion-items/promotion-items.module.ts",
		"promotion-items.module"
	],
	"./promotion-list/promotion-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/promotion-grp/promotion-list/promotion-list.module.ts",
		"common",
		"promotion-list.module"
	],
	"./promotion/promotion.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/promotion-grp/promotion/promotion.module.ts",
		"common",
		"promotion.module"
	],
	"./promotions/promotions.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/hourly-promotion/promotions/promotions.module.ts",
		"promotions.module"
	],
	"./provider/provider.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/provider/provider.module.ts",
		"provider.module"
	],
	"./public-itemLevel/public-itemLevel.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/public-itemLevel/public-itemLevel.module.ts",
		"public-itemLevel.module"
	],
	"./public-itemLevelRelation/public-itemLevelRelation.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/public-itemLevelRelation/public-itemLevelRelation.module.ts",
		"public-itemLevelRelation.module"
	],
	"./purchase-analysis/purchase-analysis.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/reports/purchase-analysis/purchase-analysis.module.ts",
		"purchase-analysis.module"
	],
	"./purchase-return-grp/purchase-return-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/purchase-return-grp/purchase-return-grp.module.ts",
		"purchase-return-grp.module"
	],
	"./purchase-return-list/purchase-return-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/purchase-return-grp/purchase-return-list/purchase-return-list.module.ts",
		"purchase-return-list.module"
	],
	"./purchase-return/purchase-return.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/purchase-return-grp/purchase-return/purchase-return.module.ts",
		"common",
		"purchase-return.module"
	],
	"./purchase/purchase.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/purchasegrp/purchase/purchase.module.ts",
		"common",
		"purchase.module"
	],
	"./purchasegrp/purchasegrp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/purchasegrp/purchasegrp.module.ts",
		"purchasegrp.module"
	],
	"./purchaselist/purchaselist.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/purchasegrp/purchaselist/purchaselist.module.ts",
		"purchaselist.module"
	],
	"./purchaseposting/purchaseposting.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/acctools/purchaseposting/purchaseposting.module.ts",
		"purchaseposting.module"
	],
	"./purchases/purchases.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/purchases.module.ts",
		"purchases.module"
	],
	"./quotation-grp/quotation-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/quotation-grp/quotation-grp.module.ts",
		"quotation-grp.module"
	],
	"./quotation-list/quotation-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/quotation-grp/quotation-list/quotation-list.module.ts",
		"quotation-list.module"
	],
	"./quotation/quotation.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/quotation-grp/quotation/quotation.module.ts",
		"common",
		"quotation.module"
	],
	"./reasons/reasons.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/reasons/reasons.module.ts",
		"reasons.module"
	],
	"./recipe/recipe.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/recipe/recipe.module.ts",
		"recipe.module"
	],
	"./reconciliation/reconciliation.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/reconciliation/reconciliation.module.ts",
		"reconciliation.module"
	],
	"./recurringtransactions-grp/recurringtransactions-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/recurringtransactions-grp/recurringtransactions-grp.module.ts",
		"recurringtransactions-grp.module"
	],
	"./recurringtransactions-list/recurringtransactions-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/recurringtransactions-grp/recurringtransactions-list/recurringtransactions-list.module.ts",
		"recurringtransactions-list.module"
	],
	"./recurringtransactions/recurringtransactions.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/recurringtransactions-grp/recurringtransactions/recurringtransactions.module.ts",
		"common",
		"recurringtransactions.module"
	],
	"./redemption/redemption.module": [
		"../../../../../src/app/lazy-modules/+private-page/loyalty/loyaltytransactions/redemption/redemption.module.ts",
		"redemption.module"
	],
	"./repacking-grp/repacking-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/repacking-grp/repacking-grp.module.ts",
		"repacking-grp.module"
	],
	"./repacking-list/repacking-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/repacking-grp/repacking-list/repacking-list.module.ts",
		"repacking-list.module"
	],
	"./repacking/repacking.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/repacking-grp/repacking/repacking.module.ts",
		"common",
		"repacking.module"
	],
	"./reportmenu/reportmenu.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/reportsettings/reportmenu/reportmenu.module.ts",
		"reportmenu.module"
	],
	"./reportprivilege/reportprivilege.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/reportsettings/reportprivilege/reportprivilege.module.ts",
		"reportprivilege.module"
	],
	"./reports/reports.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/reports/reports.module.ts",
		"reports.module"
	],
	"./reportsettings/reportsettings.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/reportsettings/reportsettings.module.ts",
		"reportsettings.module"
	],
	"./reservation-blockedhours/reservation-blockedhours.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-reservation/reservation-blockedhours/reservation-blockedhours.module.ts",
		"common",
		"reservation-blockedhours.module"
	],
	"./reservation-room/reservation-room.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-reservation/reservation-room/reservation-room.module.ts",
		"common",
		"reservation-room.module"
	],
	"./reservation-shift-grp/reservation-shift-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-reservation/reservation-shift-grp/reservation-shift-grp.module.ts",
		"reservation-shift-grp.module"
	],
	"./reservation-shift-list/reservation-shift-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-reservation/reservation-shift-grp/reservation-shift-list/reservation-shift-list.module.ts",
		"common",
		"reservation-shift-list.module"
	],
	"./reservation-shift/reservation-shift.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-reservation/reservation-shift-grp/reservation-shift/reservation-shift.module.ts",
		"common",
		"reservation-shift.module"
	],
	"./reservation-tags/reservation-tags.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-reservation/reservation-tags/reservation-tags.module.ts",
		"common",
		"reservation-tags.module"
	],
	"./rest-categoryrelease/rest-categoryrelease.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-centralization/rest-categoryrelease/rest-categoryrelease.module.ts",
		"rest-categoryrelease.module"
	],
	"./rest-centralization/rest-centralization.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-centralization/rest-centralization.module.ts",
		"rest-centralization.module"
	],
	"./rest-customer/rest-customer.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/rest-customer/rest-customer.module.ts",
		"rest-customer.module"
	],
	"./rest-imagedetails/rest-imagedetails.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/rest-imagedetails/rest-imagedetails.module.ts",
		"rest-imagedetails.module"
	],
	"./rest-info/rest-info.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/companyStructure/rest-info/rest-info.module.ts",
		"common",
		"rest-info.module"
	],
	"./rest-itemlevel/rest-itemlevel.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/rest-itemlevel/rest-itemlevel.module.ts",
		"rest-itemlevel.module"
	],
	"./rest-itemmanagement-grp/rest-itemmanagement-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-centralization/rest-itemmanagement-grp/rest-itemmanagement-grp.module.ts",
		"rest-itemmanagement-grp.module"
	],
	"./rest-itemmanagement/rest-itemmanagement.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-centralization/rest-itemmanagement-grp/rest-itemmanagement/rest-itemmanagement.module.ts",
		"rest-itemmanagement.module"
	],
	"./rest-mainsettings/rest-mainsettings.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-settings/rest-mainsettings/rest-mainsettings.module.ts",
		"rest-mainsettings.module"
	],
	"./rest-master/rest-master.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/rest-master.module.ts",
		"rest-master.module"
	],
	"./rest-menumigration/rest-menumigration.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-centralization/rest-menumigration/rest-menumigration.module.ts",
		"rest-menumigration.module"
	],
	"./rest-menurelease/rest-menurelease.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-centralization/rest-menurelease/rest-menurelease.module.ts",
		"rest-menurelease.module"
	],
	"./rest-messages/rest-messages.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/rest-messages/rest-messages.module.ts",
		"rest-messages.module"
	],
	"./rest-posprivilege/rest-posprivilege.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/rest-posprivilege/rest-posprivilege.module.ts",
		"rest-posprivilege.module"
	],
	"./rest-reservation/rest-reservation.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-reservation/rest-reservation.module.ts",
		"rest-reservation.module"
	],
	"./rest-roles/rest-roles.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-settings/rest-roles/rest-roles.module.ts",
		"rest-roles.module"
	],
	"./rest-sellingpricelevelmapping/rest-sellingpricelevelmapping.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-centralization/rest-sellingpricelevelmapping/rest-sellingpricelevelmapping.module.ts",
		"rest-sellingpricelevelmapping.module"
	],
	"./rest-settings/rest-settings.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-settings/rest-settings.module.ts",
		"rest-settings.module"
	],
	"./rest-showinmenuupdate/rest-showinmenuupdate.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/rest-showinmenuupdate/rest-showinmenuupdate.module.ts",
		"rest-showinmenuupdate.module"
	],
	"./rest-table/rest-table.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/rest-table/rest-table.module.ts",
		"rest-table.module"
	],
	"./rest-taxDetails/rest-taxDetails.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/rest-taxDetails/rest-taxDetails.module.ts",
		"rest-taxDetails.module"
	],
	"./rest-timeClock/rest-timeClock.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/rest-timeClock/rest-timeClock.module.ts",
		"rest-timeClock.module"
	],
	"./rest-tools/rest-tools.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/rest-tools.module.ts",
		"rest-tools.module"
	],
	"./rest-typecategory/rest-typecategory.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/rest-typecategory/rest-typecategory.module.ts",
		"rest-typecategory.module"
	],
	"./rest-userroles/rest-userroles.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-settings/rest-userroles/rest-userroles.module.ts",
		"rest-userroles.module"
	],
	"./restaurant/restaurant.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/restaurant.module.ts",
		"common",
		"restaurant.module"
	],
	"./restlog/restlog.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/restlog/restlog.module.ts",
		"common",
		"restlog.module"
	],
	"./restnt-consolidatereports/restnt-consolidatereports.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/restnt-report/restnt-consolidatereports/restnt-consolidatereports.module.ts",
		"common",
		"restnt-consolidatereports.module"
	],
	"./restnt-htmlreports/restnt-htmlreports.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/restnt-report/restnt-htmlreports/restnt-htmlreports.module.ts",
		"common"
	],
	"./restnt-report/restnt-report.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/restnt-report/restnt-report.module.ts",
		"restnt-report.module"
	],
	"./restnt-salesreport/restnt-salesreport.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/restnt-report/restnt-salesreport/restnt-salesreport.module.ts",
		"restnt-salesreport.module"
	],
	"./reverse-charge-grp/reverse-charge-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/reverse-charge-grp/reverse-charge-grp.module.ts",
		"reverse-charge-grp.module"
	],
	"./reverse-charge-list/reverse-charge-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/reverse-charge-grp/reverse-charge-list/reverse-charge-list.module.ts",
		"reverse-charge-list.module"
	],
	"./reverse-charge/reverse-charge.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/reverse-charge-grp/reverse-charge/reverse-charge.module.ts",
		"reverse-charge.module"
	],
	"./role/role.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/usersettings/role/role.module.ts",
		"common",
		"role.module"
	],
	"./room-level-relation/room-level-relation.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/room-level-relation/room-level-relation.module.ts",
		"room-level-relation.module"
	],
	"./room-level/room-level.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/room-level/room-level.module.ts",
		"room-level.module"
	],
	"./room-printer-mapping/room-printer-mapping.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/room-printer-mapping/room-printer-mapping.module.ts",
		"room-printer-mapping.module"
	],
	"./room/room.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/room/room.module.ts",
		"room.module"
	],
	"./sales-analysis-grid/sales-analysis-grid.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/reports/sales-analysis-grid/sales-analysis-grid.module.ts",
		"sales-analysis-grid.module"
	],
	"./sales-analysis/sales-analysis.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/reports/sales-analysis/sales-analysis.module.ts",
		"sales-analysis.module"
	],
	"./sales-report/sales-report.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/reports/sales-report/sales-report.module.ts",
		"sales-report.module"
	],
	"./sales/sales.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/sales.module.ts",
		"sales.module"
	],
	"./salesman/salesman.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/salesman/salesman.module.ts",
		"salesman.module"
	],
	"./salesorder-grp/salesorder-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/salesorder-grp/salesorder-grp.module.ts",
		"salesorder-grp.module"
	],
	"./salesorder-list/salesorder-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/salesorder-grp/salesorder-list/salesorder-list.module.ts",
		"salesorder-list.module"
	],
	"./salesorder/salesorder.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/salesorder-grp/salesorder/salesorder.module.ts",
		"common",
		"salesorder.module"
	],
	"./salesposting/salesposting/salesposting.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/salesposting/salesposting/salesposting.module.ts",
		"salesposting.module"
	],
	"./salesreturn-grp/salesreturn-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/salesreturn-grp/salesreturn-grp.module.ts",
		"salesreturn-grp.module"
	],
	"./salesreturn-list/salesreturn-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/salesreturn-grp/salesreturn-list/salesreturn-list.module.ts",
		"salesreturn-list.module"
	],
	"./salesreturn/salesreturn.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/sales/salesreturn-grp/salesreturn/salesreturn.module.ts",
		"common",
		"salesreturn.module"
	],
	"./sellingprice-branchrelation/sellingprice-branchrelation.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/sellingprice-branchrelation/sellingprice-branchrelation.module.ts",
		"sellingprice-branchrelation.module"
	],
	"./sellingprice-level/sellingprice-level.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/sellingprice-level/sellingprice-level.module.ts",
		"sellingprice-level.module"
	],
	"./size/size.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/master/size/size.module.ts",
		"size.module"
	],
	"./stateMaster/stateMaster.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/stateMaster/stateMaster.module.ts",
		"stateMaster.module"
	],
	"./stock-adjustment-grp/stock-adjustment-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/stock-adjustment-grp/stock-adjustment-grp.module.ts",
		"stock-adjustment-grp.module"
	],
	"./stock-adjustment-list/stock-adjustment-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/stock-adjustment-grp/stock-adjustment-list/stock-adjustment-list.module.ts",
		"stock-adjustment-list.module"
	],
	"./stock-adjustment/stock-adjustment.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/stock-adjustment-grp/stock-adjustment/stock-adjustment.module.ts",
		"common",
		"stock-adjustment.module"
	],
	"./stock-register/stock-register.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/reports/stock-register/stock-register.module.ts",
		"common",
		"stock-register.module"
	],
	"./stylecodegeneration/stylecodegeneration.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/stylecodegeneration/stylecodegeneration.module.ts",
		"stylecodegeneration.module"
	],
	"./supplier-grp/supplier-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/supplier-grp/supplier-grp.module.ts",
		"supplier-grp.module"
	],
	"./supplier-list/supplier-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/supplier-grp/supplier-list/supplier-list.module.ts",
		"supplier-list.module"
	],
	"./supplier/supplier.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/purchases/supplier-grp/supplier/supplier.module.ts",
		"supplier.module"
	],
	"./suppliercontrol/suppliercontrol.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/suppliercontrol/suppliercontrol.module.ts",
		"suppliercontrol.module"
	],
	"./table-layout/table-layout.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-tools/table-layout/table-layout.module.ts",
		"table-layout.module"
	],
	"./taxcode/taxcode.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/ca-master/taxcode/taxcode.module.ts",
		"taxcode.module"
	],
	"./taxvoucher-grp/taxvoucher-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/taxvoucher-grp/taxvoucher-grp.module.ts",
		"taxvoucher-grp.module"
	],
	"./taxvoucher/taxvoucher.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/taxvoucher-grp/taxvoucher/taxvoucher.module.ts",
		"common",
		"taxvoucher.module"
	],
	"./taxvoucherlist/taxvoucherlist.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/account-transactions/taxvoucher-grp/taxvoucherlist/taxvoucherlist.module.ts",
		"taxvoucherlist.module"
	],
	"./tools/commonTools.module": [
		"../../../../../src/app/lazy-modules/+private-page/tools/commonTools.module.ts",
		"common",
		"commonTools.module"
	],
	"./tools/tools.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/tools.module.ts",
		"tools.module"
	],
	"./transaction-analysis/transaction-analysis.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/reports/transaction-analysis/transaction-analysis.module.ts",
		"transaction-analysis.module"
	],
	"./transaction-details/transaction-details.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/acreports/transaction-details/transaction-details.module.ts",
		"transaction-details.module"
	],
	"./transactionperiod/transactionperiod.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/transactionperiod/transactionperiod.module.ts",
		"transactionperiod.module"
	],
	"./transactions/transactions.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/transactions.module.ts",
		"transactions.module"
	],
	"./transfer-approval/transfer-approval.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/transfer-grp/transfer-approval/transfer-approval.module.ts",
		"transfer-approval.module"
	],
	"./transfer-grp/transfer-grp.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/transfer-grp/transfer-grp.module.ts",
		"transfer-grp.module"
	],
	"./transfer-list/transfer-list.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/transfer-grp/transfer-list/transfer-list.module.ts",
		"transfer-list.module"
	],
	"./transfer/transfer.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/transactions/transfer-grp/transfer/transfer.module.ts",
		"common",
		"transfer.module"
	],
	"./transferposting/transferposting.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/acctools/transferposting/transferposting.module.ts",
		"transferposting.module"
	],
	"./trial-balance/trial-balance.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/acreports/trial-balance/trial-balance.module.ts",
		"trial-balance.module"
	],
	"./unit/unit.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/master/unit/unit.module.ts",
		"unit.module"
	],
	"./user/user.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/usersettings/user/user.module.ts",
		"common",
		"user.module"
	],
	"./userprivilege/userprivilege.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/usersettings/userprivilege/userprivilege.module.ts",
		"common",
		"userprivilege.module"
	],
	"./userrole/userrole.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/usersettings/userrole/userrole.module.ts",
		"common",
		"userrole.module"
	],
	"./usersettings/usersettings.module": [
		"../../../../../src/app/lazy-modules/+private-page/main/usersettings/usersettings.module.ts",
		"usersettings.module"
	],
	"./voucher-type/voucher-type.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/ca-master/voucher-type/voucher-type.module.ts",
		"common",
		"voucher-type.module"
	],
	"./waiter/waiter.module": [
		"../../../../../src/app/lazy-modules/+private-page/restaurant/rest-master/waiter/waiter.module.ts",
		"waiter.module"
	],
	"./weighingScaleItems/weighingScaleItems.module": [
		"../../../../../src/app/lazy-modules/+private-page/inventory/tools/weighingScaleItems/weighingScaleItems.module.ts",
		"weighingScaleItems.module"
	],
	"./zatca-report/zatca-report.module": [
		"../../../../../src/app/lazy-modules/+private-page/accounts/acreports/zatca-report/zatca-report.module.ts",
		"zatca-report.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main